import React from "react";

import { Skeleton } from "@common/skeleton";

import { Props } from "./types";
import styles from "./styles.scss";

function ProjectLoader({ style = {} }: Props) {
  return (
    <div className={styles.loader}>
      {new Array(6).fill(0).map((_, index) => (
        <Skeleton
          key={index}
          className={styles.projectElement}
          style={{
            ...(typeof style.itemHeight !== "undefined" && {
              height: style.itemHeight,
            }),
          }}
        />
      ))}
    </div>
  );
}

export { ProjectLoader };
